import { ourPresentation } from './ourPresentation';
import { livewireMinistryPresentation } from './livewireMinistryEnergyTransportTelecommunications';
import { regulatoryPresentation } from './regulatoryPresentation';
import { smallTeamsPresentation } from './smallTeamsPresentation';
import { arcgisMigrationPresentation } from './arcgisMigrationPresentation';
import { productPresentation } from './productPresentation';

export type Slide = {
	title: string;
	content: string;
	background?: string;
	backgroundImage?: string;
	backgroundVideo?: string;
	notes?: string;
	verticalSlides?: Slide[];
};

export type SlideDeck = {
	slug: string;
	name: string;
	subtitle: string;
	color: string;
	slides: Slide[];
	darkTheme?: boolean;
	customCSS?: string;
};

export const slideDecks: SlideDeck[] = [
	ourPresentation,
	livewireMinistryPresentation,
	regulatoryPresentation,
	smallTeamsPresentation,
	arcgisMigrationPresentation,
	productPresentation,
];
